import { useTranslation } from 'react-i18next';
import {
  CheckCircleOutlined,
  CheckOutlined,
  DeleteOutlined,
  EyeOutlined,
  InboxOutlined,
  KeyOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Button,
  Dropdown,
  Form,
  Layout,
  message,
  Modal,
  Popconfirm,
  Progress,
  Space,
  Switch,
  TableColumnsType,
  TableProps,
  UploadProps,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import { get, isEmpty } from "lodash";
import {
  ChangeEvent,
  FunctionComponent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";
import DetailStudentsAccountDrawer from "../../components/drawer/students-account";
import ChangePassStudentDrawer from "../../components/drawer/students-account/change-password";
import ConfirmVerifyDrawer from "../../components/drawer/students-account/confirm-request-participant";
import CommonModal from "../../components/modal/common";
import ListStudentsAccountImportModal from "../../components/modal/list-students-account-import";
import PageHeader from "../../components/page-header/PageHeader";
import TableData from "../../components/table-data/TableData";
import { HelpService } from "../../service/helper.service";
import {
  changeStatusStudentAccount,
  deleteAccountStudent,
  downloadExcelTemplate,
  exportExcelDataStudent,
  getAllStudentAccount,
  importExcelFile,
  saveApprovedAccount,
} from "../../service/list-account-student/listAccountStudent";
import {
  createUser,
  getAccountUsers,
} from "../../service/list-account-users/listAccountUsersApi";
import { getAllEnterpriseUniversityVer2 } from "../../service/management-participate-platform";
import { globalStore } from "../../stores/stores";
import { DataType } from "../../types/listUsers";
import { combineArray } from "../../utils/arrays";
import { formatOriginTime } from "../../utils/converDate";
import FormFilter from "./components/filter-group/FormFilter";
import FilterTable from "./components/filter-table/FilterTable";
import { validateFieldCreate } from "./constants/data";
import "./list-user.scss";
import { Permission } from "../../layout/sidebar/permission.enum";

type ListStudentsProps = {
  title?: string;
};

const ListStudents: FunctionComponent<ListStudentsProps> = ({ title }) => {
  const { t } = useTranslation();
  const helpService = new HelpService();
  const [params, setParams] = useSearchParams();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [IsOpenStudentsAccountAdmin, setIsOpenStudentsAccountAdmin] =
    useState<boolean>(false);
  const [isOpenChangePass, setIsOpenChangePass] = useState<boolean>(false);
  const [isOpenConfirmVerify, setIsOpenConfirmVerify] =
    useState<boolean>(false);
  const [isOpenForm, setIsOpenForm] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("desc");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("dateJoined");
  const [exportMode, setExportMode] = useState<boolean>(false);
  const [importMode, setImportMode] = useState<boolean>(false);
  const [isDisableSaveButton, setIsDisableSaveButton] = useState<boolean>(true);
  const [fileListLength, setFileListLength] = useState(0);
  const [fileList, setFileList] = useState<any>([]);
  const [countItem, setCountItem] = useState<number>(0);
  const [detailData, setDetailData] = useState<any>();
  const [accountUsers, setAccountUsers] = useState<DataType[]>([]);
  const [listEnterPrise, setListEnterPrise] = useState([]);
  const [dataOptions, setDataOptions] = useState({
    dataUnits: [],
    dataRoles: [],
    dataOffices: [],
  });

  const [filterData, setFilterData] = useState<any>({
    universityId: null,
    status: null,
    approvedDate: null,
  });

  const [pageSize, setPageSize] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isDaiHoc, setIsDaiHoc] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [uploadComplete, setUploadComplete] = useState<boolean>(false);
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false);

  const [form] = Form.useForm();
  const { personalInfo, reload } = globalStore();
  const permissions = personalInfo?.permissions;

  const exportExcel = (fileData: any, msg: string) => {
    const blob = new Blob([fileData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);

    downloadLink.download = msg;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
  };

  const getListData = async () => {
    setLoading(true);
    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      keyword: searchValue.trim() || undefined,
      universityId: check ? null : filterData.universityId,
      isDaiHoc: filterData.universityId ? isDaiHoc : false,
      sourceRegister: null,
      typeAccountStudent: null,
      createdDateFrom:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[0])
          ? `${filterData.approvedDate?.[0]}T00:00:00.000Z`
          : null,
      createdDateTo:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[1])
          ? `${filterData.approvedDate?.[1]}T00:00:00.000Z`
          : null,
      ekycStatus: filterData.status ? Number(filterData.status) : null,
    };
    if (exportMode) {
      await exportExcelDataStudent(data).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          const fileData = res.data;
          exportExcel(fileData, `${t("Kết xuất tài khoản Sinh viên", "Kết xuất tài khoản Sinh viên")}.xlsx`);
        }
      });
    } else {
      await getAllStudentAccount(data)
        .then((res) => {
          const { data } = res.data;
          setAccountUsers(data.data);
          setTotalRecords(data.total);
          setCountItem(data?.count);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
    setExportMode(false);
  };

  useEffect(() => {
    getListData();
  }, [pageSize, pageNumber, statusOrder, exportMode, reload]);

  const renderStatus = (value: number) => {
    switch (value) {
      case 0:
        return (
          <p className="p-1 border border-gray-400 rounded-md text-gray-400">{t("Chưa xác thực", "Chưa xác thực")}</p>
        );
      case 1:
        return (
          <p className="p-1 border border-blue-400 rounded-md text-blue-400">{t("Chờ duyệt", "Chờ duyệt")}</p>
        );
      case 2:
        return (
          <p className="p-1 border border-green-400 rounded-md text-green-400">{t("Hợp lệ", "Hợp lệ")}</p>
        );
      case 3:
        return (
          <p className="p-1 border border-red-400 rounded-md text-red-400">{t("Không hợp lệ", "Không hợp lệ")}</p>
        );
      default:
        break;
    }
  };

  const options = [
    ...(permissions?.includes(Permission.ChangeStudentAccountUpdate)
      ? [
          {
            key: "1",
            label: t("Đổi mật khẩu", "Đổi mật khẩu"),
            icon: <KeyOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(
      Permission.ApproveStudentAccountVerificationUpdate
    )
      ? [
          {
            key: "2",
            label: t("Duyệt xác thực", "Duyệt xác thực"),
            icon: <CheckOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(Permission.DeleteStudentAccountUpdate)
      ? [
          {
            key: "4",
            label: t("Xóa tài khoản", "Xóa tài khoản"),
            icon: <DeleteOutlined />,
            className: "dropdown-delete",
            danger: true,
          },
        ]
      : []),
  ];

  const optionsVerified = [
    ...(permissions?.includes(Permission.ChangeStudentAccountUpdate)
      ? [
          {
            key: "1",
            label: t("Đổi mật khẩu", "Đổi mật khẩu"),
            icon: <KeyOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(
      Permission.ReapproveStudentAccountVerificationUpdate
    )
      ? [
          {
            key: "2",
            label: t("Duyệt lại xác thực", "Duyệt lại xác thực"),
            icon: <CheckCircleOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(Permission.DeleteStudentAccountUpdate)
      ? [
          {
            key: "4",
            label: t("Xóa tài khoản", "Xóa tài khoản"),
            icon: <DeleteOutlined />,
            className: "dropdown-delete",
            danger: true,
          },
        ]
      : []),
  ];

  const optionsNoVerify = [
    ...(permissions?.includes(Permission.ChangeStudentAccountUpdate)
      ? [
          {
            key: "1",
            label: t("Đổi mật khẩu", "Đổi mật khẩu"),
            icon: <KeyOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(Permission.DeleteStudentAccountUpdate)
      ? [
          {
            key: "4",
            label: t("Xóa tài khoản", "Xóa tài khoản"),
            icon: <DeleteOutlined />,
            className: "dropdown-delete",
            danger: true,
          },
        ]
      : []),
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record: any, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên đăng nhập", "Tên đăng nhập"),
      dataIndex: "username",
      key: "username",
      sorter: true,
      width: 30,
    },
    {
      title: t("Họ và tên", "Họ và tên"),
      dataIndex: "name",
      key: "name",
      width: 30,
    },
    {
      title: t("Trường đại học", "Trường đại học"),
      dataIndex: "unitName",
      key: "unitName",
      width: 20,
    },
    {
      title: t("Số giấy tờ cá nhân", "Số giấy tờ cá nhân"),
      dataIndex: "cardId",
      key: "cardId",
      width: 20,
    },
    {
      title: t("Trạng thái eKYC", "Trạng thái eKYC"),
      dataIndex: "phone",
      key: "phone",
      width: 20,
      render: (_: any, record: any) => {
        return (
          <>
            <div className="flex items-center gap-2">
              {renderStatus(record?.ekycStatus)}
            </div>
          </>
        );
      },
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any) => {
        return (
          <>
            {record?.dateJoined ? formatOriginTime(record?.dateJoined) : null}
          </>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      // shouldCellUpdate(record, prevRecord) {
      //   return true
      // },
      render: (_: any, record: any) => {
        const handleChange = (
          checked: boolean,
          event: React.MouseEvent<HTMLButtonElement>
        ) => {
          record.isActive = checked;
        };

        const confirm = (id: number) => {
          const data = {
            usedId: record?.id,
            isActive: record?.isActive,
          };
          changeStatusStudentAccount(data).then((res) => {
            if (res.status === 200) {
              // record.isActive = !record?.isActive;
              helpService.successMessage(
                `${record?.isActive ? t("Mở khóa", "Mở khóa") : t("Khóa", "Khóa")} ${t("tài khoản thành công", "tài khoản thành công")}`
              );
              getListData();
            }
          });
        };

        const cancel = () => {};

        if (permissions?.includes(Permission.LockUnlockFAAccountUpdate)) {
          return (
            <Popconfirm
              description={`${t("Bạn có chắc chắn muốn", "Bạn có chắc chắn muốn")} ${
                record.isActive ? t("khóa", "khóa") : t("mở khóa", "mở khóa")
              } ${t("tài khoản?", "tài khoản?")}`}
              overlayClassName="change-status-popconfirm"
              onConfirm={() => confirm(get(record, "id"))}
              onCancel={cancel}
              okText={record.isActive ? t("Khóa", "Khóa") : t("Mở", "Mở")}
              cancelText={t("Huỷ bỏ", "Huỷ bỏ")}
              title=""
            >
              <Switch
                defaultChecked={record.isActive}
                checked={record.isActive}
                onChange={handleChange}
              />
            </Popconfirm>
          );
        } else {
          return (
            <Switch
              defaultChecked={record.isActive}
              checked={record.isActive}
              onChange={() => message.error(t("Không có quyền chỉnh sửa!", "Không có quyền chỉnh sửa!"))}
            />
          );
        }
      },
      width: 20,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record: any) => {
        return (
          <Space className="flex justify-center">
            <a
              className="action-table"
              onClick={() => {
                setIsOpenStudentsAccountAdmin(true);
                setDetailData(record);
              }}
            >
              <EyeOutlined />
            </a>
            <Dropdown
              menu={{
                items: !record.fileIdPersonal
                  ? optionsNoVerify
                  : Number(record?.ekycStatus) === 2
                  ? optionsVerified
                  : options,
                onClick: ({ key }) => {
                  if (key === "1") {
                    setIsOpenChangePass(true);
                    setDetailData(record);
                  }
                  if (key === "2") {
                    setIsOpenConfirmVerify(true);
                    setDetailData(record);
                  }
                  if (key === "3") {
                    setIsOpenConfirmVerify(true);
                    setDetailData(record);
                  }
                  if (key === "4") {
                    Modal.confirm({
                      title: t("Xóa tài khoản", "Xóa tài khoản"),
                      content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                      onOk: () => deleteAccount(record.id),
                      centered: true,
                      okText: t("Xác nhận", "Xác nhận"),
                      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                      footer: (_, { OkBtn, CancelBtn }) => (
                        <>
                          <CancelBtn />
                          <OkBtn />
                        </>
                      ),
                    });
                  }
                },
              }}
              placement="bottomRight"
            >
              <Button>
                <MoreOutlined />
              </Button>
            </Dropdown>
          </Space>
        );
      },
      fixed: "right",
      width: 15,
    },
  ];

  const defaultCheckedList = dataColumns.map((item) => item.key as string);
  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const newColumns = useMemo(() => {
    return dataColumns.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList, permissions]);

  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleClose = () => {
    setIsOpened(false);
    form.resetFields();
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleSubmitSearch = () => {
    getListData();
  };

  const check = !permissions?.includes(Permission.isQTHT);

  const clearFilter = () => {
    const allFields = form.getFieldsValue();
    const fieldsToReset = Object.keys(allFields).filter(
      (key) => key !== "universityId"
    );
    check ? form.resetFields(fieldsToReset) : form.resetFields();

    setFilterData({
      universityId: check ? filterData.universityId : null,
      status: null,
      approvedDate: null,
    });
  };

  const handleFinish = (values: any) => {
    setLoading(true);
    getAccountUsers({
      vaiTros: get(values, "vaiTros", []),
      donVis: combineArray(dataOptions.dataUnits, get(values, "donVis", [])),
      trangThai: get(values, "trangThai", []),
    }).then((res) => {
      const { data, totalRecords } = res.data.data;
      setLoading(false);
      setAccountUsers(data);
      setTotalRecords(totalRecords);
    });
  };

  const onFinishCreate = (values: any) => {
    createUser(values)
      .then((res) => {
        const { data, statusCode } = res.data;
        if (statusCode === 200) {
          helpService.successMessage(
            get(data, "message", t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
          );
          form.resetFields();
          setPageNumber(1);
          handleClose();
        }
      })
      .catch((err) => {});
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const deleteAccount = async (id: number) => {
    try {
      const res = await deleteAccountStudent(id);
      if (res.status === 200) {
        message.success(t("Xóa tài khoản thành công", "Xóa tài khoản thành công"));
        if (countItem === 1 && pageNumber > 1) {
          setPageNumber(pageNumber - 1);
        } else {
          getListData();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    if (uploadComplete && importMode) {
      setUploadProgress(70);
      timer = setInterval(() => {
        setUploadProgress((prev) => (prev < 99 ? prev + 1 : prev));
      }, 500);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [uploadComplete, importMode]);

  const changeHandler = async (event: any) => {
    setFileListLength(event.fileList.length);

    if (isEmpty(event.fileList)) {
      setFileList([]);
      return;
    }

    setFileList(event.fileList);
    const file = event.fileList[0]?.originFileObj;
    if (!file) return;

    message.warning(t("Đang import File, vui lòng đợi...", "Đang import File, vui lòng đợi..."));
    const formData = new FormData();
    formData.append("file", file);
    setImportMode(true);
    setUploadProgress(0);
    setUploadComplete(false);
    try {
      const res = await importExcelFile(formData, {
        onUploadProgress: (progressEvent: ProgressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent - 30);
            if (percent >= 100) {
              setUploadComplete(true);
            }
          }
        },
      });

      if (res.status === 200) {
        setUploadProgress(100);
        message.success(t("Import File thành công!", "Import File thành công!"));
        setImportMode(false);
        setIsDisableSaveButton(false);
      }
    } catch (err) {
      console.error(err);
      setIsDisableSaveButton(true);
    } finally {
      setImportMode(false);
    }
  };

  const propsFile: UploadProps = {
    name: "file",
    // multiple: true,
    maxCount: 1,
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        message.error(`${file.name} ${t("không phải file Excel", "không phải file Excel")}`);
      }
      return false;
    },
    onChange: changeHandler as any,
    fileList: fileList,
  };

  const handleConfirmFile = async () => {
    setIsOpenForm(true);
  };

  const downloadTemplate = async () => {
    await downloadExcelTemplate().then((res) => {
      if (res.status === 200) {
        exportExcel(res.data, `${t("File mẫu", "File mẫu")}.xlsx`);
      }
    });
  };

  const saveAccount = async () => {
    const data = {
      isApproved: true,
    };
    setLoadingApprove(true);
    await saveApprovedAccount(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Thêm sinh viên từ File thành công", "Thêm sinh viên từ File thành công"));
        setIsOpened(false);
        setIsOpenForm(false);
        getListData();
        setLoadingApprove(false);
      }
    });
  };

  // const getListEnterprise = async () => {
  //   await getAllEnterpriseUniversityVer2({}).then((res) => {
  //     if (res.status === 200) {
  //       const arr = res.data?.data?.map((item: any) => ({
  //         id: item.universityId,
  //         name: item.name,
  //         uuid: item.uuid,
  //       }));
  //       setListEnterPrise(arr);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   getListEnterprise();
  // }, [reload]);

  useEffect(() => {
    if (fileListLength === 0) {
      setIsDisableSaveButton(true);
    }
  }, [fileListLength]);

  useEffect(() => {
    setFileListLength(0);
    setFileList([]);
    setUploadProgress(0);
    setUploadComplete(false);
  }, [isOpened]);

  return (
    <Layout className="page-header-group">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createUser") {
            const { createUser } = forms;
            const data = createUser.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
          if (name === "filterForm") {
            getListData();
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
              setExportMode={setExportMode}
            />
          </div>
          <FormFilter
            form={form}
            check={check}
            showFilter={showFilter}
            filterData={filterData}
            clearFilter={clearFilter}
            setIsDaiHoc={setIsDaiHoc}
            listEnterPrise={listEnterPrise}
            setFilterData={handleChangeFilter}
            handleCloseFilter={handleCloseFilter}
          />
        </div>

        <TableData
          dataTable={accountUsers}
          dataColumns={newColumns}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalRecords}
          handleTableChangeProps={handleTableChange}
        />

        <DetailStudentsAccountDrawer
          open={IsOpenStudentsAccountAdmin}
          onClose={() => setIsOpenStudentsAccountAdmin(false)}
          detailData={detailData}
        />

        <ChangePassStudentDrawer
          open={isOpenChangePass}
          onClose={() => setIsOpenChangePass(false)}
          detailData={detailData}
          fetchData={getListData}
        />

        <ConfirmVerifyDrawer
          open={isOpenConfirmVerify}
          onClose={() => setIsOpenConfirmVerify(false)}
          detailData={detailData}
          fetchData={getListData}
        />

        <CommonModal
          open={isOpened}
          title={t("Thêm tài khoản sinh viên từ file Excel", "Thêm tài khoản sinh viên từ file Excel")}
          maskClosable={false}
          desc={
            <div className="border-b pb-3">
              <Dragger {...propsFile} showUploadList={false}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  {t("Nhấn hoặc thả tệp lên từ máy tính của bạn", "Nhấn hoặc thả tệp lên từ máy tính của bạn")}{" "}
                  <span className="text-[#1677FF]">{t("vào đây", "vào đây")}</span>
                </p>
                <p className="ant-upload-hint">
                  {t("Định dạng tệp khả dụng: CSV (Tối đa 01 tệp - 10 MB)", "Định dạng tệp khả dụng: CSV (Tối đa 01 tệp - 10 MB)")}
                </p>
              </Dragger>
              {uploadProgress > 0 && <Progress percent={uploadProgress} />}
              {uploadProgress < 100 && uploadProgress > 0 && (
                <div className="loader-upload-file" data-text={t("Hệ thống đang xử lý, xin vui lòng chờ.....", "Hệ thống đang xử lý, xin vui lòng chờ.....")}></div>
              )}
              {uploadProgress === 100 && <div>{fileList[0]?.name}</div>}
              <div className="pt-3">
                <span className="font-bold">
                  {t("Hướng dẫn các bước thêm sinh viên từ file Excel:", "Hướng dẫn các bước thêm sinh viên từ file Excel:")}
                </span>
                <ol className="list-decimal px-4">
                  <li className="list-decimal">
                    {t("Tải mẫu file Excel chuẩn mà bạn cần sử dụng", "Tải mẫu file Excel chuẩn mà bạn cần sử dụng")}{" "}
                    <span
                      className="text-[#1677FF] cursor-pointer"
                      onClick={downloadTemplate}
                    >{t('tại đây', 'tại đây')}</span>
                  </li>
                  <li className="list-decimal">
                    {t("Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp", "Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp")}
                  </li>
                  <li className="list-decimal">
                    {t("Chọn nút “Lưu“ để tải file lên hệ thống", "Chọn nút “Lưu“ để tải file lên hệ thống")}
                  </li>
                </ol>
              </div>
            </div>
          }
          closeIcon={true}
          okText={t("Lưu", "Lưu")}
          cancelText={t("Huỷ bỏ", "Huỷ bỏ")}
          icon=""
          loading={importMode}
          disableButton={isDisableSaveButton}
          confirm={handleConfirmFile}
          closeModal={() => setIsOpened(false)}
          className={"!w-full md:!w-[520px]"}
        />

        <ListStudentsAccountImportModal
          open={isOpenForm}
          loadingApprove={loadingApprove}
          handleClose={() => setIsOpenForm(false)}
          importMode={importMode}
          saveAccount={saveAccount}
        />
      </Form.Provider>
    </Layout>
  );
};

export default ListStudents;
